var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.692 9.693"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.826 3.68c.16-.15.3-.274.43-.405Q6.646 1.889 8.033.5a3.026 3.026 0 01.375-.346.8.8 0 011.04.086.773.773 0 01.083 1.037 3.114 3.114 0 01-.347.375q-1.386 1.39-2.776 2.777c-.132.132-.257.271-.409.432.148.158.272.3.4.429q1.366 1.37 2.734 2.738a3.036 3.036 0 01.346.376.807.807 0 01-.06 1 .775.775 0 01-1.032.128 2.66 2.66 0 01-.378-.342q-1.37-1.366-2.735-2.737c-.133-.135-.24-.294-.379-.467-.191.172-.321.277-.438.394Q3.046 7.785 1.639 9.196a3.426 3.426 0 01-.331.312.792.792 0 01-1.083-.055.823.823 0 01-.046-1.09 3.561 3.561 0 01.316-.327c.912-.912 1.821-1.826 2.738-2.734a5.388 5.388 0 01.468-.37c-.178-.2-.283-.327-.4-.443Q1.896 3.078.486 1.671a2.579 2.579 0 01-.341-.379A.8.8 0 011.23.177a2.357 2.357 0 01.382.338Q3.003 1.9 4.39 3.29c.138.124.279.246.436.39z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "c4e067b697c99a69c7513704c2e3bbef.svg";
export { SvgClear as ReactComponent };